import React from 'react';
import { Layout } from 'antd';

import DateContextProvider from '../Components/Context/DateContext';
import DrawerContextProvider from '../Components/Context/DrawerContext';
import FeedContextProvider from '../Components/Context/FeedContext';
import AddArticleFormDrawer from '../Components/Drawer/AddArticleForm';
import NotifContextProvider from '../Components/Context/NotifContext';
import ThemeContextProvider from '../Components/Context/ThemeContext';
import ProfileContextProvider from '../Components/Context/ProfileContext';
import PaymentContextProvider from '../Components/Context/PaymentContext';
import PremiumSection from '../Components/Static/Premium/PremiumSection';

export default function Premium(props) {
  return (
    <div>
      <ThemeContextProvider>
        <NotifContextProvider>
          <ProfileContextProvider>
            <PaymentContextProvider>
              <PremiumSection />
            </PaymentContextProvider>
          </ProfileContextProvider>
        </NotifContextProvider>
      </ThemeContextProvider>
    </div>
  );
}
